export const isVisibleInformationButton = ({ title, description }) => Boolean(title) || Boolean(description);
